import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LocalStorageService } from '../../pages/user/services/local-storage.service';
import { UserWebService } from '../../pages/user/services/user.web.service';

const REFERRAL = 'referral';
const USER = 'user';
const ORGANIZACAO_PLANO = 'organizacao_plano';
const HOME_DASHBOARD = 'pages/gestao-financeira/dashboard/resumo';
const HOME_SIMULADOR = 'pages/simulador-vendas';

@Injectable()
export class OrganizacaoAtivaService {
  private readonly organizacoes = new BehaviorSubject<Array<any>>([]);
  private readonly organizacaoAtiva = new BehaviorSubject<any>(null);
  private hidratando = false;

  constructor(
    private localStorage: LocalStorageService,
    private userService: UserWebService
  ) {
    this.publicar();
  }

  getOrganizacoes(): Array<any> {
    return this.localStorage.getOrganizacoes();
  }

  getOrganizacaoAtiva() {
    return this.localStorage.getOrganizacaoAtiva();
  }

  getOrganizacaoAtivaId(): string | null {
    return this.getOrganizacaoAtiva()?.id ?? null;
  }

  hasMultiplasOrganizacoes(): boolean {
    return this.getOrganizacoes().length > 1;
  }

  sincronizar(): void {
    this.publicar();
  }

  observeOrganizacoes(): Observable<Array<any>> {
    return this.organizacoes.asObservable();
  }

  observeOrganizacaoAtiva(): Observable<any> {
    return this.organizacaoAtiva.asObservable();
  }

  setOrganizacaoAtiva(organizacaoId: string): boolean {
    const organizacao = this.getOrganizacoes().find(
      (candidata) => candidata?.id === organizacaoId
    );

    if (!organizacao) return false;

    this.localStorage.setOrganizacaoAtivaId(organizacao.id);
    this.localStorage.set(REFERRAL, organizacao.referral);
    this.localStorage.remove(ORGANIZACAO_PLANO);
    this.publicar();

    return true;
  }

  hidratarOrganizacoes(): void {
    if (this.hidratando) return;
    if (this.localStorage.getOrganizacoesHidratadas()) return;
    if (!this.localStorage.getUser()) return;

    this.hidratando = true;

    this.recarregarOrganizacoes().subscribe(
      () => {
        this.hidratando = false;
      },
      () => {
        this.hidratando = false;
      }
    );
  }

  recarregarOrganizacoes(): Observable<void> {
    return this.userService
      .getSelf()
      .pipe(map((recarregado: any) => this.aplicarOrganizacoes(recarregado)));
  }

  getHomeRoute(): string {
    const permissoes = this.localStorage.getUserPermissions() ?? [];
    const role = this.localStorage.getRole() ?? '';
    const notBasicRoles = !role.includes('iniciante') && !role.includes('basico');

    return permissoes.includes('dashboard') && notBasicRoles
      ? HOME_DASHBOARD
      : HOME_SIMULADOR;
  }

  private aplicarOrganizacoes(recarregado: any): void {
    const user = this.localStorage.getUser();
    if (!user || !recarregado?.organizacoes?.length) return;

    const anteriores = new Map<string, any>(
      (user.organizacoes ?? []).map((organizacao: any) => [organizacao?.id, organizacao])
    );

    user.organizacoes = recarregado.organizacoes.map((organizacao: any) => ({
      ...(anteriores.get(organizacao?.id) ?? {}),
      ...organizacao,
    }));

    this.localStorage.setObject(USER, user);
    this.localStorage.setOrganizacoesHidratadas();
    this.publicar();
  }

  private publicar() {
    this.organizacoes.next(this.getOrganizacoes());
    this.organizacaoAtiva.next(this.getOrganizacaoAtiva());
  }
}
